import { render, staticRenderFns } from "./paidserve.vue?vue&type=template&id=9dedcc20&scoped=true&"
import script from "./paidserve.vue?vue&type=script&lang=js&"
export * from "./paidserve.vue?vue&type=script&lang=js&"
import style0 from "./paidserve.vue?vue&type=style&index=0&id=9dedcc20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dedcc20",
  null
  
)

export default component.exports